// Autogenerated file, DO NOT MODIFY or it will be overwritten;
import type { SVGProps } from 'react';

import { forwardRef } from '@chakra-ui/react';

import { Icon, type IconProps } from '../Icon';

const Svg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M4 13.3335C4 11.8608 5.13779 10.3335 6.54109 10.3335H9.45891C10.8622 10.3335 12 11.8608 12 13.3335M9.62703 4.67424C10.526 5.57323 10.526 7.03077 9.62703 7.92976 8.72804 8.82875 7.27049 8.82875 6.37151 7.92976 5.47252 7.03077 5.47252 5.57323 6.37151 4.67424 7.27049 3.77525 8.72804 3.77525 9.62703 4.67424"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M9.33268 13.3333H12.9993C13.736 13.3333 14.3327 12.7367 14.3327 12V3.33333C14.3327 2.59667 13.736 2 12.9993 2H2.99935C2.26268 2 1.66602 2.59667 1.66602 3.33333V12C1.66602 12.7367 2.26268 13.3333 2.99935 13.3333H6.66602L7.99935 14.6667L9.33268 13.3333Z"
      clipRule="evenodd"
    />
  </svg>
);
const IconUserProfile = forwardRef((props: Omit<IconProps, 'icon'>, ref) => {
  return <Icon ref={ref} icon={Svg} {...props} />;
});
export default IconUserProfile;
